import { appBottombar } from '@styles/theme'
import styled from '@emotion/styled/macro'

import { LoaderLogo } from './LoaderLogo'

import { austinMapBackground } from '@assets/images/austin-map-background'

const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100vh;
  width: 100vw;

  background: url('${austinMapBackground}');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  // For consistent alignment of logo with map loader
  padding-bottom: ${appBottombar};
`

const AppLaunchLoader = () => {
  return (
    <Container>
      <LoaderLogo>
        Mandrake App
      </LoaderLogo>
    </Container>
  )
}

export default AppLaunchLoader
